// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".remove-margin{margin-left:-20px;margin-top:-21px;margin-right:-20px}.stats-wrapper{display:grid;grid-template-columns:repeat(5, 1fr);grid-template-rows:auto auto}.cell-top{font-size:12px;color:#fff}.cell-bottom{padding-bottom:10px;padding-top:10px;color:#fff}", ""]);
// Exports
module.exports = exports;
